import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { GET_ALL_Video, Get_Mantra_Topic } from "../../gql/queries";
import { Link, NavLink, useNavigate, useParams ,useLocation} from "react-router-dom";
import { GET_Bookmarked_Video } from "../../gql/mutation";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { useEffect } from "react";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
export default function MantraListing(){
	const navigate = useNavigate()
	const completePathUrl = useLocation()
	let [selectId, selectMantra] = useState();
	let { id } = useParams();
	const[course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
	const [open, setStatus] = useState(0);
	const query1 = useQuery(GET_ALL_Video, {
		variables: {
			"courseName": course.preparingFor,
			"version": 0,
			"status": true,
			"contentType": "pearl",
			"isRoot": true
		},
		fetchPolicy: 'network-only',
	});
	const query2 = useQuery(Get_Mantra_Topic, {
        variables: {
			"_id": id,
			"language": "English",
			"contentType": "pearl"
		},
	});
	// console.log(query2?.data?.layer?.subLayers[0]?._id,"kkkkkkkkkkk")
			const [getBookmark] = useMutation(GET_Bookmarked_Video, {
        refetchQueries: [
			{
				query: Get_Mantra_Topic, variables: {
                    "_id": id,
                    "language": "English",
                    "contentType": "pearl"
                }
            }, // DocumentNode object parsed with gql
            'videolayer' // Query name,
			
        ],
    });
	useEffect(()=> {
		firstSelect()
    }, []);

	const firstSelect = async ()=>{
		const response = await query2.refetch();
		if (response && response?.data) {
			selectMantra(response.data?.layer?.subLayers[0]?._id);
		}
	}

	// console.log(query2?.data?.layer?.subLayers[0]._id, "dsadklasdklas");
	if (query1.loading||query2.loading) {
		return (<><Loader/></>)
		
	}
	if (query1.error||query2.error) {
		if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')||query2.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
            } 
			else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')||query2.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
				return (<>
					<div className="main_wrapper">
						<div className="col-lg-12">
							<SomethingWentWrong pathName={completePathUrl.pathname} />
						</div>
					</div>
				</>)
			}
			else {
				return (<>
	  					<div className="main_wrapper">
    					   <div className="col-lg-12">
    					       <ConnectionError pathName={completePathUrl.pathname}/>
    					   </div>
    					   </div>
							</>)

            }
	}
	
	const selectedMantras =(manData) => {
		selectId= manData;
		selectMantra(manData);
	}
	console.log(selectId,"selectId");
    return(
        <div className="main_wrapper">
			<div className="breadcrumbs">
				<ul className="breadcrumb">
					<li className="breadcrumb-item"><a >Home</a></li>
					<li className="breadcrumb-item"><a >Mantras</a></li>
					{/* <li className="breadcrumb-item active"><a href="/">Anatomy Mantras</a></li> */}
				</ul>
			</div>
			<section className="videoLayer_wrapper mantraList_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="topics_wrapper_main">
                            <div className="subjects_wrapper topic_header">
								<div className="topic_image_ttl d-flex align-items-baseline">
									<figure className="back_arrow">
										<Link to={'/mantras'}>
										<img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
										</Link>
									</figure>
									<figure className="subject_inner_img">
										<img src={query2.data&&query2.data.layer.icon? query2.data.layer.icon:Icons.Anatomy} alt="Subject Image" className="img-fluid" />
									</figure>
									<div className="subject_ttl_detail">
										<h5>{query2.data&&query2.data.layer.title} ({query2.data&&query2.data?.layer?.subLayers?.length})</h5>
									</div>
								</div>
                            </div>

                            <div className="recommended_video_wrapper">
                                <div id="accordion">
									{
										query2.data&&query2.data.layer.subLayers.map((d, i)=>(
											<div className={`mantra_list_card ${d._id===selectId ? 'selected': ''}`} onClick={()=>selectedMantras(d._id)}>
												<div className="manList_hedr">
													<a className="card-link" data-toggle="collapse" href={`#collapse${i}`}>
														<div className="manSub_content d-flex align-items-center">
															<figure className="sub_img">
																<img src={d.icon?d.icon:Images.defaultImg} alt="Name" className="img-fluid"/>
															</figure>
															<div className="manSub_text">
																<h6>{d.title} <span>({d.totalContent})</span></h6>
															</div>
														</div>
														<span className="sub_arrow">
															<img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
														</span>
													</a>
												</div>
												<div id={`collapse${i}`} className={`${open == i ? 'collapse show' : 'collapse'}`} data-parent="#accordion">
													<div className="manList_body">
														{
															d.subContents&&d.subContents.map((m,index)=>(
																<div className="manList_body_content">
																	<div className="manList_bookmark d-flex align-items-center">
																		<div className="man_label">
																			<span className="mantra_number">No. <span className="num">{m?.pearl?.pearlsCode}</span></span>
																		</div>
																		{
																			m?.pearl?.progress?.isBookMarked === false && 
																				<div className="bookmark_lable">
																					<img src={Icons.Bookmark} alt="" className="img-fluid" onClick={()=> getBookmark({
																						variables: {
																							contentType: "Pearl","topicId": m.pearl.subjectDetail.topicId, "subjectId":  m.pearl?.subjectDetail?.subjectId, "contentId": m.pearl?._id, "isCompleted": false, "courseName": course.preparingFor, "isBookMarked": true
																						}
																					})}/>
																				</div>
																		}
																		{
																			m?.pearl?.progress?.isBookMarked === true &&
																			<div className="bookmark_lable">
																				<img src={Icons.unBookmark} alt="" className="img-fluid" onClick={()=> getBookmark({
																						variables: {
																							contentType: "Pearl","topicId": m.pearl.subjectDetail.topicId, "subjectId":  m.pearl.subjectDetail.subjectId, "contentId": m.pearl._id, "isCompleted": false, "courseName": course.preparingFor, "isBookMarked": false
																						}
																					})}/>
																			</div>
																		}
																		{
																			m?.pearl?.progress?.isBookMarked === null &&
																			<div className="bookmark_lable">
																				<img src={Icons.Bookmark} alt="" className="img-fluid" onClick={()=> getBookmark({
																						variables: {
																							contentType: "Pearl","topicId": m.pearl.subjectDetail.topicId, "subjectId":  m.pearl.subjectDetail.subjectId, "contentId": m.pearl._id, "isCompleted": false, "courseName": course.preparingFor, "isBookMarked": true
																						}
																					})}/>
																			</div>
																		}
																	</div>
																	<Link to ={`/mantras/mantrascontent/${index}/${id}/mantra/${i}`} state={JSON.stringify(d)}>
																		<div className="manList_quesname d-flex align-items-center">
																			<div className="manques_name">
																				<p>{m?.pearl?.title}</p>
																			</div>
																			<div className="man_arrow">
																				<img src={Icons.QbRightArrow} alt="" className="img-fluid"/>
																			</div>
																		</div>
																	</Link>
																</div>
															))
														}
														{/* <div className="manList_body_content">
															<div className="manList_bookmark d-flex align-items-center">
																<div className="man_label">
																	<span className="mantra_number">No. <span className="num">786</span></span>
																</div>
																<div className="bookmark_lable">
																	<img src={Icons.Bookmark} alt="" className="img-fluid"/>
																</div>
															</div>
															<div className="manList_quesname d-flex align-items-center">
																<div className="manques_name">
																	<p>Muscles Of Mastication & Their Actions</p>
																</div>
																<div className="man_arrow">
																	<img src={Icons.QbRightArrow} alt="" className="img-fluid"/>
																</div>
															</div>
														</div> */}
													</div>
												</div>
											</div>
										))
									}
									{/* <div className="mantra_list_card">
										<div className="manList_hedr">
											<a className="card-link" data-toggle="collapse" href="#collapseTwo">
												<div className="manSub_content d-flex align-items-center">
													<figure className="sub_img">
														<img src={Icons.Brain} alt="Name" className="img-fluid"/>
													</figure>
													<div className="manSub_text">
														<h6>Head, Neck & Face<span>(2)</span></h6>
													</div>
												</div>
												<span className="sub_arrow">
													<img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
												</span>
											</a>
										</div>
										<div id="collapseTwo" className="collapse" data-parent="#accordion">
											<div className="manList_body">
												<div className="manList_body_content">
													<div className="manList_bookmark d-flex align-items-center">
														<div className="man_label">
															<span className="mantra_number">No. <span className="num">786</span></span>
														</div>
														<div className="bookmark_lable">
															<img src={Icons.Bookmark} alt="" className="img-fluid"/>
														</div>
													</div>
													<div className="manList_quesname d-flex align-items-center">
														<div className="manques_name">
															<p>Muscles Of Mastication & Their Actions</p>
														</div>
														<div className="man_arrow">
															<img src={Icons.QbRightArrow} alt="" className="img-fluid"/>
														</div>
													</div>
												</div>
												<div className="manList_body_content">
													<div className="manList_bookmark d-flex align-items-center">
														<div className="man_label">
															<span className="mantra_number">No. <span className="num">786</span></span>
														</div>
														<div className="bookmark_lable">
															<img src={Icons.Bookmark} alt="" className="img-fluid"/>
														</div>
													</div>
													<div className="manList_quesname d-flex align-items-center">
														<div className="manques_name">
															<p>Muscles Of Mastication & Their Actions</p>
														</div>
														<div className="man_arrow">
															<img src={Icons.QbRightArrow} alt="" className="img-fluid"/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="mantra_list_card">
										<div className="manList_hedr">
											<a className="card-link" data-toggle="collapse" href="#collapseThree">
												<div className="manSub_content d-flex align-items-center">
													<figure className="sub_img">
														<img src={Icons.Brain} alt="Name" className="img-fluid"/>
													</figure>
													<div className="manSub_text">
														<h6>Head, Neck & Face<span>(2)</span></h6>
													</div>
												</div>
												<span className="sub_arrow">
													<img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
												</span>
											</a>
										</div>
										<div id="collapseThree" className="collapse" data-parent="#accordion">
											<div className="manList_body">
												<div className="manList_body_content">
													<div className="manList_bookmark d-flex align-items-center">
														<div className="man_label">
															<span className="mantra_number">No. <span className="num">786</span></span>
														</div>
														<div className="bookmark_lable">
															<img src={Icons.Bookmark} alt="" className="img-fluid"/>
														</div>
													</div>
													<div className="manList_quesname d-flex align-items-center">
														<div className="manques_name">
															<p>Muscles Of Mastication & Their Actions</p>
														</div>
														<div className="man_arrow">
															<img src={Icons.QbRightArrow} alt="" className="img-fluid"/>
														</div>
													</div>
												</div>
												<div className="manList_body_content">
													<div className="manList_bookmark d-flex align-items-center">
														<div className="man_label">
															<span className="mantra_number">No. <span className="num">786</span></span>
														</div>
														<div className="bookmark_lable">
															<img src={Icons.Bookmark} alt="" className="img-fluid"/>
														</div>
													</div>
													<div className="manList_quesname d-flex align-items-center">
														<div className="manques_name">
															<p>Muscles Of Mastication & Their Actions</p>
														</div>
														<div className="man_arrow">
															<img src={Icons.QbRightArrow} alt="" className="img-fluid"/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div> */}
								</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12">
						<div className="subjects_wrapper Subject_selection_right_side">
							<div className="subjects_header">
                                <h6>Move to other Subject</h6>
                            </div>
							<div className="all_subjects_name_wrapper">
								<ul type="none" className="subjects_child d-flex flex-wrap">
									{
										query1.data&&query1.data?.layers?.map(d=>(
											<li>
												<NavLink to={`/mantras/mantraslisting/${d._id}`}>
													<div className="subject_main_list d-flex align-itmes-center">
														<div className="subject_img_wrap d-flex align-items-center">
															<figure className="subject_img">
																<img src={d.icon?d.icon:Images.defaultImg} alt="" className="img-fluid" />
															</figure>
															<div className="subject_details">
																<h6>{d?.title}</h6>
																<p>{d?.description}</p>
															</div>
														</div>	
													</div>
												</NavLink>
											</li>
										))
									}
									{/* <li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Forensic Medicine</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Physiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Microbiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li> */}
								</ul>
							</div>
						</div>
					</div>
                </div>
            </section>
        </div>
    )
}